import React, { Component } from "react";
import { Column } from "@ant-design/plots";
import { AppRoutes } from "../../../AppRoutes";

class AdnColumn extends Component {
    shouldComponentUpdate(nextProps) {
        if (
            nextProps.employeeFollowUpEventsconfig.data !==
            this.props.employeeFollowUpEventsconfig.data
        ) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        return (
            <Column
                {...this.props.employeeFollowUpEventsconfig}
                onEvent={(...args) => {
                    if (args[1].type == "plot:click" && args[1].data != null) {
                        const data = args[1].data.data || {};
                        
                        const getUserName = () => {
                            const name = data.userName;
                            if (!name || name === "Not Done" || name === "Canceled/ Not Assigned") {
                                return "";
                            }
                            return String(name);
                        };
                        
                        const getValue = (value, defaultValue = "") => {
                            if (value === null || value === undefined || value === "undefined") {
                                return defaultValue;
                            }
                            return String(value);
                        };
                        
                        let userName = getUserName();
                        let followUpEventYear = getValue(data.year);
                        let followUpEventMonth = getValue(data.month);
                        let followUpEventStatus = getValue(data.originalStatus || data.status);
                        let employeeName = getValue(data.employeeName || data.employee || data.consultantName);
                        let eventType = getValue(data.eventType || data.eventTypeName || data.type);
                        
                        let statusFormatted = "";
                        if (followUpEventStatus) {
                            const statusLower = followUpEventStatus.toLowerCase();
                            if (statusLower === "not assigned" || statusLower === "notassigned") {
                                statusFormatted = "Not assigned";
                            } else if (statusLower === "not done" || statusLower === "notdone") {
                                statusFormatted = "Not done";
                            } else if (statusLower === "done") {
                                statusFormatted = "Done";
                            } else if (statusLower === "canceled" || statusLower === "cancelled") {
                                statusFormatted = "Canceled";
                            } else {
                                statusFormatted = followUpEventStatus;
                            }
                        }
                        
                        this.props.navigate(
                            AppRoutes.followUpEventList.createPathWithSearch(
                                userName,
                                followUpEventMonth,
                                followUpEventYear,
                                statusFormatted,
                                employeeName,
                                eventType
                            )
                        );
                    }
                }}
            />
        );
    }
}

export default AdnColumn;
